<template>
<section class="w1312 main-content-wrap">
  <section>
    <div class="info-container">
      <dl class="clearfix">
        <dt>
          <imgWrap :src="userInfo.avatarUrl" width="120" height="120" :alt="userInfo.name" :item="userInfo" :pic="'avatarUrl'"/>
        </dt>
        <dd>
          <p class="user-label">
            <span v-for="(item, index) in userInfo.identities" :key="`${item}-${index}`">{{item.name || item.code}}</span>
          </p>
          <p class="user-name">
            {{userInfo.username}}
          </p>
        </dd>
      </dl>
    </div>
    <div style="padding: 24px 0; text-align: center;">
      <tabs :modelValue="activeTabName" :options="tabList" @update:modelValue="newValue => activeTabName = newValue" @tab-click="handleClick"/>
    </div>
    <section class="recommend-container">
      <div class="tab-container clearfix">
        <template v-if="activeTabName === tabList[0].value">
          <ul class="clearfix">
            <li v-for="(item, index) in (activeTabName === tabList[0].value ? tabs : examTabs)" :key="index" :class="{'active': activeTabName === tabList[0].value ? item.value === this.activeName : item.value === this.activeExamName}" @click="activeTabName === tabList[0].value ? toggleTab(item.value) : toggleExamTab(item.value)"  mars_sead="vschool_gerenzhongxin_mycoursestate_link" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'mycoursestate': item.label })">
              {{item.label}}
              <span class="line"></span>
            </li>
          </ul>
        </template>
        <template v-else>
          <ul class="clearfix">
            <li v-for="(item, index) in (activeTabName === tabList[0].value ? tabs : examTabs)" :key="index" :class="{'active': activeTabName === tabList[0].value ? item.value === this.activeName : item.value === this.activeExamName}" @click="activeTabName === tabList[0].value ? toggleTab(item.value) : toggleExamTab(item.value)"  mars_sead="vschool_gerenzhongxin_mycoursestate_link" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'mycoursestate': item.label })">
              {{item.label}} ({{ item.total > 99 ? item.total + '+' : item.total }})
              <span class="line"></span>
            </li>
          </ul>
        </template>
      </div>
      <div class="list-container">
        <view-container :loading="loading" :empty="empty" :error="error" @retry="loadData" v-if="activeTabName === tabList[0].value">
          <ul>
            <li v-for="(item, index) in myCoursesList" :key="index" :class="{'disabled': item.isDeleted}" @click="checkDelete(item.isDeleted)">
              <dl>
                <dt>
                  <span v-if="item.isDeleted">
                    <imgWrap :src="item.coverUrl" width="304" height="194" :alt="item.title" :item="item" :pic="'coverUrl'"/>
                  </span>
                  <router-link :to="{ name: 'CourseDetail', params: {target: item.target, courseId: item.courseId}}" mars_sead="vschool_gerenzhongxin_mycoursestate_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})" target="_blank" v-else>
                    <imgWrap :src="item.coverUrl" width="304" height="194" :alt="item.title" :item="item" :pic="'coverUrl'"/>
                  </router-link>
                  <p class="schedule-box">
                    <span class="text" :style="{width: (item.learningProgress || 0) + '%', 'color': item.learningProgress ? '#fff' : '#FD3374'}">
                      <i style="font-style: normal; padding-right: 5px;font-size:10px;" :style="{'paddingLeft': !item.learningProgress ? '5px' : '0'}">{{(item.learningProgress || 0)}}%</i>
                    </span>
                    <span class="content" :style="{width: (item.learningProgress || 0) + '%'}"></span>
                  </p>
                </dt>
                <dd>
                  <p class="list-title">
                    <a href="javascript:;" v-if="item.isDeleted">
                      {{item.title}}
                    </a>
                    <router-link :to="{ name: 'CourseDetail', params: {target: item.target, courseId: item.courseId}}" mars_sead="vschool_gerenzhongxin_mycoursestate_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})" target="_blank" v-else>
                      {{item.title}}
                    </router-link>
                  </p>
                  <p class="list-tips">
                    <span v-if="item.duration">
                      时长
                      {{parseDuration(item.duration)}}
                    </span>
                    <span v-if="item.hot">
                      <i class="eye-icon"></i>
                      {{item.hot}}
                    </span>
                  </p>
                </dd>
              </dl>
            </li>
          </ul>
          <pagination v-model:pageModal="pageDTO" @query="loadData()" :pageSizeList="[8, 12, 16, 32]"/>
        </view-container>
        <view-container :loading="loading" :empty="empty || !myExamsList.length" :error="error" @retry="loadData" v-if="activeTabName === tabList[1].value">
          <div class="info-container">
            <div class="info-list clearfix" v-for="(item, index) in myExamsList" :key="index">
              <div class="info-right">
                <examLink :item="item"></examLink>
              </div>
              <div class="info-left">
                <div class="exam-title">
                  <span class="pass" v-if="item.lastExamResult === 1">已通过</span>
                  <span class="noPass" v-else>未通过</span>
                  {{item.title}}
                </div>
                <div class="module-box mrg-top-10">
                  <span class="item-box">
                    及格：{{formatScore(item.passScore)}}
                  </span>
                  <span class="item-box" v-if="item.lastExamResult === 1">
                    得分：{{formatScore(item.score)}}
                  </span>
                  <span class="item-box">
                    总分：{{formatScore(item.totalScore)}}
                  </span>
                  <span class="item-box">
                    ID：{{item.examNo}}
                  </span>
                </div>
                <div class="module-box">
                  <!-- <span class="item-box">
                    题目总数：{{item.questionCount}}
                  </span> -->
                  <span class="item-box">
                    时长：{{formatDuration(item.duration)}}
                  </span>
                  <span class="item-box" v-if="item.lastExamResult === 1">
                    完成时间：{{formatTime(item.completedTime)}}
                  </span>
                  <span class="item-box">
                    截止时间：{{formatTime(item.deadline)}}
                  </span>
                  <span class="item-box">
                    交卷人数：{{item.finishCount}}
                  </span>
                </div>
                <div class="module-box">
                  <span class="item-box">
                    简介：{{item.examIntro || '~'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <pagination v-model:pageModal="pageDTO" :pageSizeList="[5, 10, 20]"/>
        </view-container>
      </div>
    </section>
  </section>
</section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import pic from '../../assets/img/production-pic.png'
import pagination from '@/components/pagination.vue'
import util from '@/util/index.js'
import imgWrap from '@/components/imgWrap'
import tabs from '@/components/tabs'
import mixins from '../examCenter/mixins'
export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      pic,
      activeName: 0,
      tabs: [
        {
          label: '学习中',
          value: 0
        },
        {
          label: '已学完',
          value: 1
        }
      ],
      pageDTO: {
        pageNo: 1,
        pageSize: 9,
        total: 0
      },
      loading: false,
      empty: false,
      error: false,
      activeTabName: 'myCourse',
      tabList: [
        {
          label: '我的课程',
          value: 'myCourse'
        },
        {
          label: '在线考试',
          value: 'myExam'
        }
      ],
      examTabs: [
        {
          label: '未完成',
          value: 0,
          total: 0
        },
        {
          label: '已通过',
          value: 1,
          total: 0
        }
      ],
      activeExamName: 0,
      examList: []
    }
  },
  computed: {
    ...mapState(['userInfo', 'myCoursesList', 'myCoursesListCount', 'sessionTarget', 'queryUserPromise']),
    myExamsList () {
      const {
        pageNo,
        pageSize
      } = this.pageDTO
      return this.examList.slice((pageNo - 1) * pageSize, pageNo * pageSize)
    }
  },
  mounted () {
    this.queryUserPromise.then(() => {
      this.loadData()
    })
  },
  methods: {
    loadData () {
      if (this.activeTabName === this.tabList[0].value) {
        this.pageDTO.pageSize = 9
        this.toggleTab()
      } else {
        this.pageDTO.pageSize = 5
        this.toggleExamTab()
      }
    },
    toggleTab (activeName = this.activeName) {
      this.activeName = activeName
      const {
        pageNo,
        pageSize
      } = this.pageDTO
      this.loading = true
      this.empty = false
      this.error = false
      let queryMyCoursesPromise = this.queryMyCourses({
        completed: this.activeName,
        pageNo,
        pageSize
      })
      let queryMyCourseCountPromise = this.queryMyCourseCount({
        completed: this.activeName
      })
      Promise.all([queryMyCoursesPromise, queryMyCourseCountPromise]).then((resp) => {
        this.pageDTO.total = resp[1] || 0
        if (!this.pageDTO.total) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
        this.empty = false
      }).finally(() => {
        this.loading = false
      })
    },
    toggleExamTab (activeName = this.activeExamName) {
      this.activeExamName = activeName
      this.loading = true
      this.empty = false
      this.error = false
      console.log(33, this.activeExamName)
      this.pageDTO.total = 0
      let queryMyCoursesPromise0 = this.queryMyExams(0)
      let queryMyCoursesPromise1 = this.queryMyExams(1)
      Promise.all([queryMyCoursesPromise0, queryMyCoursesPromise1]).then((resp) => {
        this.examTabs[0].total = resp[0].length
        this.examTabs[1].total = resp[1].length
        if (this.activeExamName === 1) {
          this.examList = resp[1]
          this.pageDTO.total = resp[1].length
        } else {
          this.examList = resp[0]
          this.pageDTO.total = resp[0].length
        }
      }).catch(() => {
        this.error = true
        this.empty = false
      }).finally(() => {
        this.loading = false
      })
    },
    checkDelete (isDeleted) {
      if (isDeleted) {
        this.$message.warning('对不起，当前课程已删除')
      }
    },
    ...mapActions(['queryMyCourses', 'queryMyCourseCount', 'queryMyExams']),
    parseDuration: util.parseDuration,
    handleClick (e) {
      console.log(222, e)
      this.loadData()
    }
  },
  components: {
    pagination,
    imgWrap,
    tabs
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  min-height: 216px;
  border-radius: 8px;
  background: #fff;
  margin-top: 20px;
  dl {
    padding-top: 42px;
    margin-left: 40px;
    dt {
      float: left;
      width: 120px;
      height: 120px;
      border-radius: 120px;
      overflow: hidden;
    }
    dd {
      float: left;
      margin-left: 30px;
      display: inline-block;
      .user-label {
        font-size: 18px;
        line-height: 32px;
        color: #E01F54;
        span {
          background: #fce9ee;
          display: inline-block;
          margin-right: 10px;
          padding: 0 14px;
          border-radius: 3px;
        }
      }
      .user-name {
        margin-top: 20px;
        font-size: 24px;
        line-height: 34px;
        font-weight: bold;
      }
    }
  }
}
.recommend-container {
  .tab-container {
    margin-top: 40px;
    h1 {
      float: left;
      font-size: 24px;
      line-height: 34px;
      margin: 0;
    }
    ul {
      float: left;
      text-align: center;
      li {
        display: inline-block;
        color: #666;
        font-size: 18px;
        line-height: 34px;
        margin: 0 40px 0 0;
        position: relative;
        cursor: pointer;
        .line {
          position: absolute;
          left: 50%;
          top: 23px;
          width: 20px;
          height: 3px;
          background: #FF2F5D;
          margin-top: 10px;
          margin-left: -10px;
          display: none;
        }
      }
      .active {
        color: #333;
        .line {
          display: block;
        }
      }
    }
  }
  .list-container {
    margin-top: 35px;
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -16px;
      margin-right: -16px;
      li{
        flex: 0 0 25%;
        margin-bottom: 32px;
        &.disabled {
          color: #ddd!important;
          opacity: 0.7;
          & dd p {
            color: #ddd!important;
          }
          a, a:link, a:visited {
            color: #ddd!important;
          }
        }
      }
    }
    dl {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      margin: 0 16px;
      height: 100%;
      dt {
        width: 304px;
        height: 194px;
        position: relative;
        .schedule-box {
          position: absolute;
          width: 96%;
          margin-left: 2%;
          bottom: 10px;
          background: #fff;
          height: 12px;
          border-radius: 100px;
          span {
            position: absolute;
            height: 100%;
            &.text {
              text-align: right;
              color: #fff;
              z-index: 2;
              width: 80%;
              top: -2px;
              font-size: 12px;
              line-height: 16px;
            }
            &.content {
              width: 80%;
              background:#FD3374;
              border-radius: 100px;
              z-index: 1;
            }
          }
        }
      }
      dd {
        font-size: 16px;
        line-height: 22px;
        color: #333;
        font-weight: bold;
        padding-left: 16px;
        padding-top: 8px;
        .list-title {
          width: 274px;
          height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: normal;
          padding-top: 6px;
          padding-bottom: 3px;
        }
        p.list-tips {
          font-size: 12px;
          font-weight: normal;
          color: #666;
          text-align: right;
          font-family: Arial, Helvetica, sans-serif;
          padding-top: 5px;
          padding-bottom: 5px;
          padding-right: 16px;
          .eye-icon {
            background: url(../../assets/img/search_icon_show@2x.png) no-repeat;
            background-size: 14px;
            display: inline-block;
            width: 14px;
            height: 12px;
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.info-container {
  min-height: 216px;
  border-radius: 8px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  .info-list {
    border-bottom: 1px solid #F3F5F7;
    padding-top: 32px;
    margin-left: 32px;
    margin-right: 32px;
    padding-bottom: 32px;
    &:last-child {
      border-bottom: 0px;
    }
  }
  .info-left {
    margin-right: 150px;
  }
  .info-right {
    float: right;
  }
  .exam-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #333;
    .pass {
      display: inline-block;
      background:#21A663;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
      line-height: 18px;
      height: 18px;
      padding: 0 4px;
    }
    .noPass {
      display: inline-block;
      background:#F6445D;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
      line-height: 18px;
      height: 18px;
      padding: 0 4px;
    }
  }
  .module-box {
    .item-box {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      padding: 3px 0;
      margin-right: 26px;
    }
  }
}
</style>
